import React from 'react'
import About from './About'
import Footer from './Footer'
import Hero from './Hero'
import OurWay from './OurWay'
import Service from './Service'

const Home = () => {
  return (
    <div>
        <Hero/>
        <Service/>
        <OurWay/>
        <About/>
        <Footer/>
      </div>
  )
}

export default Home
